module.exports = __webpack_public_path__ + "img/CUVDA.fb5a3b31.jpg";